import { useMutation } from '@tanstack/react-query';
import {
  fetchOnDemandAiAnalysis,
  type OnDemandAiAnalysisParams,
  type OnDemandAiAnalysisResponse
} from '../services/analyticsService';

export const useOnDemandAiAnalysis = () => {
  return useMutation<OnDemandAiAnalysisResponse, Error, OnDemandAiAnalysisParams>({
    mutationFn: (params: OnDemandAiAnalysisParams) => fetchOnDemandAiAnalysis(params),
    // You can add onSuccess, onError, onSettled callbacks here if needed globally
    // For example, to invalidate queries or show notifications.
  });
}; 